var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 28 29", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#clip0_24973_32309)" },
      React.createElement("path", { d: "M14 28.44c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14z", fill: "#D64000" }),
      React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.788 9.248a1.4 1.4 0 0 0-1.98 1.98l3.21 3.21-3.21 3.21a1.4 1.4 0 1 0 1.98 1.98l3.21-3.21 3.21 3.21a1.4 1.4 0 0 0 1.98-1.98l-3.21-3.21 3.21-3.21a1.4 1.4 0 0 0-1.98-1.98l-3.21 3.21-3.21-3.21z", fill: "#fff" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "clip0_24973_32309" },
        React.createElement("path", { fill: "#fff", transform: "translate(0 .44)", d: "M0 0h28v28H0z" })
      )
    )
  );
});